import { dew as _constants2Dew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = removeComments;
  var _constants = _constants2Dew();
  function removeComments(node) {
    _constants.COMMENT_KEYS.forEach(key => {
      node[key] = null;
    });
    return node;
  }

  //# sourceMappingURL=removeComments.js.map
  return exports;
}